import { enableProdMode, isDevMode } from '@angular/core';
import { environment } from './environments/environment.dev';
import { bootstrapApplication } from '@angular/platform-browser';
import { MainLayout } from '@layouts/main/main.layout';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import Aura from '@primeuix/themes/aura';
import httpSessionInterceptor from '@common/interceptors/http-session.interceptor';
import httpResponseInterceptor from '@common/interceptors/http-response.interceptor';
import tokenValidator from '@common/interceptors/token-validator.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import APP_ROUTING  from '@app/app.routing';
import { ServiceWorkerModule } from '@angular/service-worker';
import { importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { CurrencyPipe } from '@angular/common';

if (environment.production) {
  enableProdMode();
  window.console.log = () => { }
}

bootstrapApplication(MainLayout,{
  providers: [
    provideRouter(APP_ROUTING),
    MessageService,
    CurrencyPipe,
    ConfirmationService,
    provideHttpClient(
      withInterceptors([
        httpSessionInterceptor,
        tokenValidator,
        httpResponseInterceptor
      ])
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      translation: {
        cancel: 'Cancelar',
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: [
          'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
          'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ],
        monthNamesShort: [
          'ene', 'feb', 'mar', 'abr', 'may', 'jun',
          'jul', 'ago', 'sep', 'oct', 'nov', 'dic'
        ],
      },
      theme: {
          preset: Aura,
          options: {
            darkModeSelector: false
          }
      }
    }),
    importProvidersFrom(
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
      })
    )
  ]
})
.catch(err => console.error(err));
